export default "<div class=\"wrapper wrapper-full-page\">\n\n</div>\n"